import(/* webpackMode: "eager", webpackExports: ["PageClient"] */ "/home/runner/work/joyboy/joyboy/apps/web/app/[deviceTheme]/[region]/[locale]/reviews/page.client.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/joyboy/joyboy/libs/modules/others/components/src/lib/ContactUsContainer/ContactUsContainer.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/joyboy/joyboy/libs/modules/others/components/src/lib/DeliveryReviewContainer/DeliveryReviewContainer.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/joyboy/joyboy/libs/modules/others/components/src/lib/HeadBanner/HeadBanner.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/joyboy/joyboy/libs/modules/others/components/src/lib/PageNotFoundContainer/PageNotFoundContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewContainer"] */ "/home/runner/work/joyboy/joyboy/libs/modules/others/components/src/lib/ReviewContainer/ReviewContainer.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/joyboy/joyboy/libs/modules/others/components/src/lib/ShopTheLookContainer/components/ShopTheLookTopBar.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/joyboy/joyboy/libs/modules/others/components/src/lib/ShopTheLookContainer/ShopTheLookContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmptyWishlist"] */ "/home/runner/work/joyboy/joyboy/libs/modules/others/components/src/lib/WishlistContainer/components/EmptyWishlist/EmptyWishlist.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WishlistContainer"] */ "/home/runner/work/joyboy/joyboy/libs/modules/others/components/src/lib/WishlistContainer/WishlistContainer.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/joyboy/joyboy/libs/shared/observability/src/lib/client-logging.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/joyboy/joyboy/libs/shared/utils/src/lib/hooks/use-scroll-lock.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/joyboy/joyboy/packages/monorepo-i18n/src/lib/scripts/useTranslation.client.ts");
;
import(/* webpackMode: "eager", webpackExports: ["formatCurrencyClient"] */ "/home/runner/work/joyboy/joyboy/packages/monorepo-i18n/src/lib/utils/currency-format.client.ts");
;
import(/* webpackMode: "eager", webpackExports: ["getLocaleClient"] */ "/home/runner/work/joyboy/joyboy/packages/monorepo-i18n/src/lib/utils/locale.client.ts");
